import { useEffect } from 'react';

/*
 * Ricerca e filtri sulla stessa riga (regola SUI 03/10/2026, tutte le liste): la riga non va a capo.
 * 1. Prima si stringe il campo cerca, mai sotto la larghezza di tre parole (CSS, min-width).
 * 2. Se ancora non ci sta, i tasti dei filtri diventano più piccoli (classe `is-compatta`).
 * 3. Solo se nemmeno così ci sta, la riga va a capo (classe `is-a-capo`).
 * La misura si fa nel fotogramma successivo: cambiare classe dentro il ResizeObserver lo farebbe ripartire in loop.
 */
export const useFiltriSullaRiga = (ref) => {
    useEffect(() => {
        const riga = ref.current;
        if (!riga || !riga.querySelector('.sid-list-header__filter') || typeof ResizeObserver === 'undefined') return undefined;
        let fotogramma = 0;
        let larghezza = -1;
        const sborda = () => riga.scrollWidth > riga.clientWidth + 1;
        const misura = () => {
            fotogramma = 0;
            if (riga.clientWidth === larghezza) return;
            larghezza = riga.clientWidth;
            riga.classList.remove('is-compatta', 'is-a-capo');
            if (!sborda()) return;
            riga.classList.add('is-compatta');
            if (sborda()) riga.classList.add('is-a-capo');
        };
        const osserva = new ResizeObserver(() => {
            if (!fotogramma) fotogramma = requestAnimationFrame(misura);
        });
        osserva.observe(riga);
        return () => {
            osserva.disconnect();
            if (fotogramma) cancelAnimationFrame(fotogramma);
        };
    }, [ref]);
};
